import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const API_BASE_URL = `${environment.apiUrl}/v2/management/`;

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	//Auth
	login = API_BASE_URL + 'adminLogin';

	//User
	getUserList = API_BASE_URL + 'getUserList';
	editUserDetail = API_BASE_URL + 'editUserDetail';
	deleteUser = API_BASE_URL + 'deleteUser/';
	blockRider = API_BASE_URL + 'riderBlock';
	blockUser = API_BASE_URL + 'userBlock ';
	updateUserStatus = API_BASE_URL + 'updateUserStatus';
	getUserDetail = API_BASE_URL + 'getUserDetail';
	manageStatus = API_BASE_URL + 'manageStatus';
	editFollownser = API_BASE_URL + 'editFollownser';
	getPriceEstimatesList = API_BASE_URL + 'getPriceEstimatesList';
	getPriceEstimatesDetails = API_BASE_URL + 'getPriceEstimatesDetails';
	addPriceEstimates = API_BASE_URL + 'addPriceEstimates';
	updatePriceEstimates = API_BASE_URL + 'updatePriceEstimates';
	deletePriceEstimates = API_BASE_URL + 'deletePriceEstimates/';
	viewPriceEstimates = API_BASE_URL + 'viewPriceEstimates';
	getSummaryTransactions = API_BASE_URL + 'getSummaryTransactions';
	getSoccerTransactions = API_BASE_URL + 'getSoccerTransactions';
	addAmountToWallet = API_BASE_URL + 'addAmountToWallet';
	addAmountToSoccer = API_BASE_URL + 'addAmountToSoccer';
	userTemporaryBlock = API_BASE_URL + 'userTemporaryBlock';
	getTemplatesList = API_BASE_URL + 'getTemplatesList';
	addTemplate = API_BASE_URL + 'addTemplate';
	editTemplate = API_BASE_URL + 'editTemplate';
	deleteTemplate = API_BASE_URL + 'deleteTemplate/';
	getImagesLog = API_BASE_URL + 'getImagesLog';
	get_car_images_list = API_BASE_URL + 'get_car_images_list';
	getCrm = API_BASE_URL + 'getCrm';
	addCrm = API_BASE_URL + 'addCrm';

	//Driver
	getDriverList = API_BASE_URL + 'getDriverList';
	deleteDriver = API_BASE_URL + 'deleteDriver/';
	activeDrivers = API_BASE_URL + 'activeDrivers';
	updateDriverStatus = API_BASE_URL + 'updateDriverStatus';
	editDriverDetail = API_BASE_URL + 'editDriverDetail';
	deleteCarImage = API_BASE_URL + 'deleteCarImage/';
	getDriverDetail = API_BASE_URL + 'getDriverDetail';
	getDriverRatting = API_BASE_URL + 'getDriverRatting';
	editTopPriority = API_BASE_URL + 'editTopPriority';

	//Ride
	getRideList = API_BASE_URL + 'getRideList';
	getPendingRideList = API_BASE_URL + 'getPendingRideList';
	getRunningRideList = API_BASE_URL + 'getRunningRideList';
	getCompletedRideList = API_BASE_URL + 'getCompletedRideList';
	getNoResponseRideList = API_BASE_URL + 'getNoResponseRideList';
	getCanceledRideList = API_BASE_URL + 'getCanceledRideList';
	getNoDriverFoundTrips = API_BASE_URL + 'getNoDriverFoundTrips';
	getTripLifeCycle = API_BASE_URL + 'getTripLifeCycle';
	getRecentFailures = API_BASE_URL + 'getRecentFailures';
	getFakeRideList = API_BASE_URL + 'getFakeRideList';
	completeRide = API_BASE_URL + 'completeRide';
	getLogsList = API_BASE_URL + 'getLogsList';
	deleteRide = API_BASE_URL + 'deleteRide';

	//Reviews
	getDriverReviews = API_BASE_URL + 'getDriverReviews';
	getRiderReviews = API_BASE_URL + 'getRiderReviews';
	viewDriverReviews = API_BASE_URL + 'viewDriverReviews';
	viewRiderReviews = API_BASE_URL + 'viewRiderReviews';

	//Cards
	getCardCategoriesList = API_BASE_URL + 'getCardCategoriesList';
	addCardCategory = API_BASE_URL + 'addCardCategory';
	editCardCategory = API_BASE_URL + 'editCardCategory';
	deleteCardCategory = API_BASE_URL + 'deleteCardCategory/';
	getPrepaidCardsList = API_BASE_URL + 'getPrepaidCardsList';
	getAllPrepaidCardsList = API_BASE_URL + 'getAllPrepaidCardsList';
	generationPrepaidCards = API_BASE_URL + 'generationPrepaidCards';
	showMake = API_BASE_URL + 'showMake/';
	addMake = API_BASE_URL + 'addMake';
	editMake = API_BASE_URL + 'editMake';
	deleteMake = API_BASE_URL + 'deleteMake/';

	//Challenges
	getChallengesList = API_BASE_URL + 'getChallengesList';
	editChallenges = API_BASE_URL + 'editChallenges';
	getChallengeWorksList = API_BASE_URL + 'getChallengeWorksList';
	editChallengeWorks = API_BASE_URL + 'editChallengeWorks';
	getRecentlyAddressesList = API_BASE_URL + 'getRecentlyAddressesList';
	editRecentlyAddresses = API_BASE_URL + 'editRecentlyAddresses';
	updateChallengeStatus = API_BASE_URL + 'update-challenge-status/';

	//Ride Area Setting
	getRideAreaList = API_BASE_URL + 'getRideAreaList';
	addAreaBoundaries = API_BASE_URL + 'addAreaBoundaries';
	viewAreaBoundaries = API_BASE_URL + 'viewAreaBoundaries';
	deleteAreaBoundaries = API_BASE_URL + 'deleteAreaBoundaries/';

	// Car
	getCarCategoriesList = API_BASE_URL + 'getCarCategoriesList';
	getMakesList = API_BASE_URL + 'getMakesList';

	// car-categories
	getCarCategories = API_BASE_URL + 'getCarCategoriesList';
	editCarCategory = API_BASE_URL + 'updateCarCategory';

	// car-category-tags
	getCarCategoryTags = API_BASE_URL + 'getCarCategoryTags';
	addCarCategoryTag = API_BASE_URL + 'addCarCategoryTag';
	updateCarCategoryTag = API_BASE_URL + 'updateCarCategoryTag/';
	deleteCarCategoryTag = API_BASE_URL + 'deleteCarCategoryTag/';

	getCarColors = `${environment.apiUrl}/v2/drivers/car-colors`;
	getCarModels = `${environment.apiUrl}/v2/drivers/car-models/`;

	//Promotion User List
	getUserPromotionList = API_BASE_URL + 'getUserPromotionList';
	redeemPromotionList = API_BASE_URL + 'redeemPromotionList';

	//Options
	getOptionsDetail = API_BASE_URL + 'getOptions';
	updateOptions = API_BASE_URL + 'updateOptions';

	//Send Notification
	sendNotification = API_BASE_URL + 'sendNotification';
	getSpecificUserList = API_BASE_URL + 'getSpecificUserList';

	//Targeted Notification
	getTargetedNotificationAudienceCount = API_BASE_URL + 'getTargetedNotificationAudienceCount';
	sendTargetedNotification = API_BASE_URL + 'sendTargetedNotification';

	//Contact Us
	getContactUsList = API_BASE_URL + 'getContactUsList';
	viewContactUsMessage = API_BASE_URL + 'viewContactUsMessage';
	deleteContactUs = API_BASE_URL + 'deleteContactUs/'

	//Page
	getPageList = API_BASE_URL + 'getPageList';
	addPage = API_BASE_URL + 'addPage';
	editPage = API_BASE_URL + 'editPage';
	deletePage = API_BASE_URL + 'deletePage/';

	//Admin
	getSubAdminList = API_BASE_URL + 'getSubAdminList';
	updateSubAdminStatus = API_BASE_URL + 'updateSubAdminStatus';
	addSubAdmin = API_BASE_URL + 'addSubAdmin';
	editSubAdmin = API_BASE_URL + 'editSubAdmin/';
	deleteSubAdmin = API_BASE_URL + 'deleteSubAdmin/';
	getSubAdminDetails = API_BASE_URL + 'getSubAdmin';

	//Log Details
	getDriverOnlineLog = API_BASE_URL + 'getDriverOnlineLog';

	//Update Admin Profile
	updateAdminProfile = API_BASE_URL + 'updateAdminProfile';

	//Dashboard
	getDashboardData = API_BASE_URL + 'getDashboardData';
	getNewDashboardData = API_BASE_URL + 'getNewDashboardData';
	runCommadNewDashData = API_BASE_URL + 'runCommadNewDashData';

	//Driver Subscriptions
	getDriverSubscriptionsLists = API_BASE_URL + 'driver-subscriptions-list';
	showDriverSubscription = API_BASE_URL + 'show-driver-subscriptions/';
	addDriverSubscription = API_BASE_URL + 'add-driver-subscription';
	updateDriverSubscription = API_BASE_URL + 'edit-driver-subscription';
	deleteDriverSubscription = API_BASE_URL + 'delete-driver-subscription/';

	//Driver Subscriptions Transactions
	getDriverSubscriptionTransactionsLists = API_BASE_URL + 'driver-subscription-transactions-list';
	deleteDriverSubscriptionTransaction = API_BASE_URL + 'delete-driver-subscription-transaction/';
	updateDriverSubscriptionTransactionStatus = API_BASE_URL + 'update-driver-subscription-transaction-status/';

	//Promotions
	getPromotionsLists = API_BASE_URL + 'getPromotionsLists';
	showPromotions = API_BASE_URL + 'showPromotions/';
	addPromotions = API_BASE_URL + 'addPromotions';
	updatePromotions = API_BASE_URL + 'updatePromotions';
	deletePromotions = API_BASE_URL + 'deletePromotions/';

	//Promotions Links
	getPromotionLinksLists = API_BASE_URL + 'getPromotionLinksLists';
	showPromotionLinks = API_BASE_URL + 'showPromotionLinks/';
	addPromotionLinks = API_BASE_URL + 'addPromotionLinks';
	updatePromotionLinks = API_BASE_URL + 'updatePromotionLinks';
	deletePromotionLinks = API_BASE_URL + 'deletePromotionLinks/';
	downloadLinkQRCode = API_BASE_URL + 'downloadLinkQRCode/';

	//Roles
	getRolesLists = API_BASE_URL + 'getRolesLists';
	getPermissionsList = API_BASE_URL + 'getPermissionsList';
	addRole = API_BASE_URL + 'addRole';
	updateRole = API_BASE_URL + 'updateRole';
	showRole = API_BASE_URL + 'showRole/';
	deleteRole = API_BASE_URL + 'deleteRole/';

	//Questions
	getQuestionList = API_BASE_URL + 'question-list';
	showQuestion = API_BASE_URL + 'show-question/';
	addQuestion = API_BASE_URL + 'add-question';
	editQuestion = API_BASE_URL + 'edit-question';
	updateQuestionStatus = API_BASE_URL + 'update-question-status/';
	deleteQuestion = API_BASE_URL + 'delete-question/';

	//Search
	getSearchUsersList = API_BASE_URL + 'getSearchUsersList';
	getSearchRidesList = API_BASE_URL + 'getSearchRidesList';

	//ETA
	getEtasList = API_BASE_URL + 'getEtasList';
	showEta = API_BASE_URL + 'showEta/';
	addEta = API_BASE_URL + 'addEta';
	editEta = API_BASE_URL + 'editEta';
	deleteEta = API_BASE_URL + 'deleteEta/';
}
